import { createContext, useContext, useId } from 'react'

import {
	useDownloadOptions,
	useDownloadTrack,
} from './DownloadOptionsModal.hooks'
import {
	DownloadContextValue,
	DownloadProviderProps,
} from './DownloadOptionsModal.types'

const DownloadContext = createContext<DownloadContextValue | null>(null)

export const DownloadProvider = ({
	children,
	initialTracks,
	isSelection,
	modalId: modalIdProp,
	trackSource,
	zipFileName,
}: DownloadProviderProps): JSX.Element => {
	const downloadOptionsState = useDownloadOptions(initialTracks)
	const resolvedZipFileName = zipFileName?.trim() || trackSource
	const isTrackRowDownload = initialTracks.length === 1 && !isSelection
	const trackRowTrackId = isTrackRowDownload ? initialTracks[0].id : undefined
	const downloadTrackState = useDownloadTrack(
		trackSource,
		resolvedZipFileName,
		trackRowTrackId
	)
	const generatedModalId = `download-options-modal-${useId().replaceAll(
		':',
		''
	)}`
	const modalId = modalIdProp ?? generatedModalId

	return (
		<DownloadContext.Provider
			value={{
				...downloadOptionsState,
				...downloadTrackState,
				isSelection,
				modalId,
				initialTracks,
			}}
		>
			{children}
		</DownloadContext.Provider>
	)
}

export const useDownloadContext = (): DownloadContextValue => {
	const context = useContext(DownloadContext)

	if (!context) {
		throw new Error('useDownloadContext must be used within DownloadProvider')
	}

	return context
}
